export default __webpack_public_path__ + "static/ky-89bdd0e80629988fa21053c5297ba7f5.svg";